import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CONVERSATION_AI_STATUSES } from "@/api/types";
import { ConversationsPage } from "@/features/conversations/conversations-page";
import { baseListSearch, optionalEnum, optionalString } from "@/lib/list-state";

export const Route = createFileRoute("/_authenticated/conversations/")({
  validateSearch: z.object({ ...baseListSearch, organizationId: optionalString, storeId: optionalString, aiStatus: optionalEnum(CONVERSATION_AI_STATUSES) }),
  head: () => ({ meta: [{ title: "Conversations · Rogue Admin" }] }),
  component: ConversationsPage,
});
